import React from 'react';
import PaymentSummaryTable from '../features/summary/PaymentSummaryTable';
import UnmatchedTransactionsList from "../features/transactions/UnmatchedTransactionsList";
import BalanceVerification from '../features/summary/BalanceVerification';
import PageHeader from '../components/PageHeader';

const SummaryPage: React.FC<{ refresh: boolean, onAssign: () => void, startDate: string | null, endDate: string | null, schoolYear: string }> = ({ refresh, onAssign, startDate, endDate, schoolYear }) => {
    return (
        <div className="page">
            <PageHeader title="Podsumowanie" subtitle={`Rok szkolny ${schoolYear}`} />
            <BalanceVerification refresh={refresh} />
            <UnmatchedTransactionsList refresh={refresh} onAssign={onAssign}/>
            <PaymentSummaryTable refresh={refresh} startDate={startDate} endDate={endDate} schoolYear={schoolYear} />
        </div>
    );
};

export default SummaryPage;
